/* global I18n */
import React from 'react';

const translationKeyElement = document.getElementById('translation-keys');
const translationsKeys = translationKeyElement
  ? translationKeyElement.getAttribute('data-translations')
  : '{}';
const translationParsedKeys = JSON.parse(translationsKeys);

/**
 * Higher-order component to inject translation function `t`
 * @param {string} key - The translation namespace/key prefix
 */
const withTranslation = (key) => (WrappedComponent) => {
  const WithTranslation = (props) => {
    const t = (suffix, values = {}) => {
      return I18n.t(`${key}${suffix}`, { ...translationParsedKeys, ...values });
    };

    return <WrappedComponent {...props} t={t} />;
  };

  WithTranslation.displayName = `WithTranslation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithTranslation;
};

export default withTranslation;
export { translationParsedKeys };
